// import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import moment from "moment";

class VideoMonitoringStore {
  deviceListArray = [];
  playbackData = [];

  constructor(rootStore) {
    makeObservable(this, {
      deviceListArray: observable,
      playbackData: observable,
      getDevices: action,
      getPlayBackVideoNew: action,
      getPlaybackData: action,
      stopBsjVideo: action,
      getPlaybackVideoData: action,
      bsjVideoMonitoring: action,
    });
    this.rootStore = rootStore;
  }

  async getDevices(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=getdevices2",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("VideoMonitoring/getDevicesData", {
        params: postData,
      });

    this.deviceListArray = response?.data?.data?.vehicles;
    // let this.deviceListArray = this.deviceListArray;

    Object.keys(this.deviceListArray).map((e, i) => {
      let r = this.deviceListArray[i];

      const diff = moment(r.currtime).diff(r.updatedate, "minutes");

      var vehicleTypeNew = r.vehicleTypeNew.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";

      if (diff >= 90) {
        this.deviceListArray[i].listImage = vehicleTypeNew + "-gray.png";
        this.deviceListArray[i].rowBackground = "gray";
        this.deviceListArray[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        this.deviceListArray[i].listImage = vehicleTypeNew + "-yellow.png";
        this.deviceListArray[i].rowBackground = "yellow";
        this.deviceListArray[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.acc == 0) {
        this.deviceListArray[i].listImage = vehicleTypeNew + "-red.png";
        this.deviceListArray[i].rowBackground = "red";
        this.deviceListArray[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.acc == null || (r.acc == 1 && r.speed > 0)) {
        this.deviceListArray[i].listImage = vehicleTypeNew + "-green.png";
        this.deviceListArray[i].rowBackground = "green";
        this.deviceListArray[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }
      this.deviceListArray[i].mapImage = this.deviceListArray[i].listImage;
      try {
        require("../assets/images/detailtracking/" +
          this.deviceListArray[i].listImage);
      } catch (err) {
        this.deviceListArray[i].listImage = defaultImage;
      }
      try {
        require("../assets/images/livetracking/" +
          this.deviceListArray[i].mapImage);
      } catch (err) {
        this.deviceListArray[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });

    return response.data.data?.vehicles;
  }

  async getPlayBackVideoNew(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=getPlayBackVideoNew",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "VideoMonitoring/getPlaybackVideoNew",
        postData
      );
    return response.data.data[0];
  }

  async getPlaybackData(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=getbsjdata",
    //     "postData=" + base64Input
    //   );

    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("VideoMonitoring/getBsjData", {
        params: postData,
      });
    this.playbackData = response?.data?.data;
    return response;
  }

  async getPlaybackVideoData(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=bsjPlaybackVideoMonitoring",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "VideoMonitoring/bsjPlaybackVideoMonitoring",
        postData
      );

    return response?.data?.data;
  }

  async stopBsjVideo(data) {
    var postData = {
      channelId: data.logicalChannelNumber,
      full_imei: data.terminalPhone,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=bsjVideoStopCommand",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "VideoMonitoring/bsjVideoStopCommand",
        postData
      );
    return response;
  }

  async bsjVideoMonitoring(data) {
    var postData = {
      channelId: data.channelId,
      vehicleId: data.vehicleId,
      full_imei: data.full_imei,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "VideoMonitoring/bsjVideoMonitroing",
        postData
      );
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=bsjVideoMonitoring",
    //     "postData=" + base64Input
    //   );
    return response;
  }
  async howenMDVRSocket(data) {
    var postData = data;
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=videoStreaming&a=howenMDVRVideoMonitoring",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post(
        "VideoMonitoring/howenMDVRVideoMonitroing",
        postData
      );
    return response;
  }
}

export default VideoMonitoringStore;
